"use client";

import { AiOutlineLoading3Quarters } from "react-icons/ai";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./Toast";
import { useToast } from "./use-toast";
import { FaCheckCircle } from "react-icons/fa";
import { FaTimesCircle } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";

export function Toaster() {
  const { toasts } = useToast();
  const toastIcons = (variant) => {
    switch (variant) {
      case "success":
        return <FaCheckCircle size={30} className="text-green-700" />;
      case "danger":
        return <FaTimesCircle size={30} className="text-red-500" />;
      case "info":
        return <FaInfoCircle size={30} className="text-blue-500" />;
      case "loading":
        return <AiOutlineLoading3Quarters size={30} className="animate-spin" />;
      default:
        return;
    }
  };
  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        title,
        description,
        action,
        loading,
        status,
        ...props
      }) {
        return (
          <Toast key={id} {...props}>
            <div className="flex gap-2 items-center">
              <div className="max-w-max self-center">{toastIcons(status)}</div>
              <div className="flex-1 grid gap-[2px]">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
